import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { Menu } from "../../../components/menu-consultas";

export const LayoutConsultaCelular: React.FC = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <MUI.Stack pt={[2, 0]} flexDirection="row" width="100%" height="80vh">
      <Menu
        titulo="Alerta Celular"
        menu={[
          {
            to: "/alerta/consulta-celular",
            label: "Consulta imei",
            icon: <Icon.DeviceUnknown sx={{ color: "white" }} />,
            isSelected: pathname === "/alerta/consulta-celular",
          },
          {
            to: "/alerta/consulta-celular-nome",
            label: "Consulta nome",
            icon: <Icon.DeviceUnknown sx={{ color: "white" }} />,
            isSelected: pathname === "/alerta/consulta-celular-nome",
          },
          {
            to: "/pagina-inicial",
            icon: <Icon.KeyboardReturn sx={{ color: "white" }} />,
            label: "Voltar página inicial",
          },
        ]}
      />
      <MUI.Stack flex={1} padding={2} gap={1} overflow="auto">
        {children}
      </MUI.Stack>
    </MUI.Stack>
  );
};
